import "./StatusMessage.css";
import { CircleAlert, CircleCheck, CircleEllipsis, CircleHelp } from "lucide-preact";

function StatusIcon({ type }) {
  if (type === "info") {
    return <CircleHelp class="status-message-icon" />;
  }

  if (type === "pending") {
    return <CircleEllipsis class="status-message-icon" />;
  }

  if (type === "success") {
    return <CircleCheck class="status-message-icon" />;
  }

  if (type === "warning" || type === "error") {
    return <CircleAlert class="status-message-icon" />;
  }

  return null;
}

export function StatusMessage({ type = "pending", message = "" }) {
  const icon = <StatusIcon type={type} />;

  return (
    <span class={`status-message status-message--${type}`}>
      {icon ? (
        <span class="status-message-icon-wrap" aria-hidden="true">
          {icon}
        </span>
      ) : null}
      <span class="status-message-text">{message}</span>
    </span>
  );
}
